<template>
    <div v-if="webshopSettings().hasMultipleDispatchTypes" class="relative">
        <transition name="fade">
            <div v-if="checkout().datesOrTimesLoading" class="absolute inset-0 z-20 flex cursor-not-allowed flex-col items-center justify-center gap-2 overflow-hidden bg-white/80">
                <Icon :icon="IconLoading" class="absolute size-4 animate-spin" />
            </div>
        </transition>
        <ul
            class="flex flex-row items-center justify-between rounded-full bg-gray-200 p-[0.3rem] text-center"
        >
            <li
                v-for="dispatchType in webshopSettings()?.global?.dispatchTypes"
                :key="dispatchType"
                class="w-full"
            >
                <!-- TODO: fix issue where !important is needed on cursor-not-allowed -->
                <DispatchTypeLink
                    class="flex w-full cursor-pointer flex-col rounded-full px-4 py-2 text-center leading-none transition-colors duration-200 ease-in-out"
                    :class="{
                        'bg-white': checkout().input.dispatchTypeProxy === dispatchType,
                        '!cursor-not-allowed': checkout().datesOrTimesLoading || (dispatchType === DispatchTypeOrderBuddy.DELIVER ? !webshopSettings().deliveryIsEnabled : !webshopSettings().pickupIsEnabled), // TODO: I believe we do not need this anymore
                        'hover:bg-gray-100': !checkout().datesOrTimesLoading && (dispatchType === DispatchTypeOrderBuddy.DELIVER ? webshopSettings().deliveryIsEnabled : webshopSettings().pickupIsEnabled),
                        'hover:bg-white': !checkout().datesOrTimesLoading && ((dispatchType === DispatchTypeOrderBuddy.DELIVER ? !webshopSettings().deliveryIsEnabled : !webshopSettings().pickupIsEnabled) && checkout().input.dispatchTypeProxy === dispatchType)
                    }"
                    :disabled="checkout().datesOrTimesLoading || (dispatchType === DispatchTypeOrderBuddy.DELIVER ? !webshopSettings().deliveryIsEnabled : !webshopSettings().pickupIsEnabled)"
                    :dispatch-type="dispatchType"
                    :click="() => checkout().setDispatchTypeProxy(dispatchType)"
                    :close-callback="() => checkout().setDispatchTypeProxy(checkout().input.dispatchType)"
                    :reset-callback="() => closeModals()"
                >
                    <div
                        class="flex w-full items-center justify-center gap-2"
                        :class="{
                            'text-gray-400': dispatchType === DispatchTypeOrderBuddy.DELIVER ? !webshopSettings().deliveryIsEnabled : !webshopSettings().pickupIsEnabled
                        }"
                    >
                        <Icon
                            :icon="dispatchType === DispatchTypeOrderBuddy.DELIVER ? IconDelivery : IconPickup"
                            class="text-lg"
                        />
                        <span>
                            {{ $t(`homePage.dispatchComponent.${dispatchType}`) }}
                        </span>
                    </div>
                    <CartTitleTimeIndication :dispatch-type="dispatchType" />
                </DispatchTypeLink>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import IconLoading from 'assets/icons/loading.svg'
    import { useVfm } from 'vue-final-modal'
    import IconDelivery from '@/assets/icons/delivery.svg'
    import IconPickup from '@/assets/icons/pickup.svg'
    import Icon from '@/components/Icon.vue'
    import CartTitleTimeIndication from '~/components/Cart/CartTitleTimeIndication.vue'
    import DispatchTypeLink from '~/components/DispatchTypeLink.vue'
    import { checkout } from '~/store/checkout'
    import { webshopSettings } from '~/store/webshopSettings'
    import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
    function closeModals () {
        const vfm = useVfm()
        const { closeAll } = vfm
        closeAll()
    }
</script>
